import oAuth from '../../helpers/oauth';

const logout = () => oAuth.signOut();

export default logout;
